if ($(window).width() <= 767) {
$('.navigation .navigation__tier-1 > li.navigation__item > .navigation__tier-2-container').slideUp();
$('.navigation .navigation__tier-1 > li > a').click(function(){
    $(this).parent().siblings().find('.navigation__tier-2-container').slideUp();
    $(this).parent().siblings().removeClass('active');
    $(this).parent().siblings().find('.navigation__children-toggle').removeClass('active');
    $(this).next('.navigation__children-toggle').toggleClass('active');
    $(this).next('.navigation__tier-2-container').slideToggle();
  })
}


$('.collection_inner_info').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "200px",
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24" fill="none"><path d="M12.3125 23L0.998791 11.6863L12.3125 0.372583" stroke="#1E1D1D"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24" fill="none"><path d="M0.484375 23L11.7981 11.6863L0.484375 0.372583" stroke="#1E1D1D"/></svg></button>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        arrows: false,
        centerPadding: "100px",
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerMode: true,
         arrows: false,
        centerPadding: "50px",
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
         arrows: false,
        centerPadding: "36px",
      }
    }
  ]
});

if ($(window).width() <= 767) {
  $('.product_media_row').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}



document.addEventListener("DOMContentLoaded", function () {
    let searchInput = document.querySelector(".main-search__input");
    let productGrid = document.querySelector(".collection-serch-custome_div");

    function toggleProductGrid() {
        if (searchInput.value.trim() === "") {
            productGrid.style.display = "block"; // Hide if input is empty
        } else {
            productGrid.style.display = "none"; // Show if input has value
        }
    }

    // Hide the grid initially
    toggleProductGrid();

    // Add event listener for input changes
    searchInput.addEventListener("input", toggleProductGrid);
});


$(window).scroll(function(){
    if ($(window).scrollTop() >= 10) {
        $('body').addClass('fixed_header');
    }
    else {
        $('body').removeClass('fixed_header');
    }
});

$('.mobile-navigation-drawer__footer .search_mb').click(function(e){
    e.preventDefault();
    $('body').addClass('show-search');
})


$(document).ready(function(){
  if($('buy-buttons.buy-buttons-row button').hasClass('sold-out-btn')){
    $('.product-form ').addClass('sold_out_product');
  }
})

